<template>
  <el-dialog
    :visible.sync="showDialog"
    append-to-body
    class="dialog-binduserinfoqrcode"
    title=""
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
    :show-close="false"
  >
    <template slot="title">
      <img
        class="icon-delete"
        src="@/assets/icon_dialog_delete.png"
        @click="handleCloseDialog"
      />
    </template>
    <div class="dialog-container">
      <div class="title-box">独自开小程序</div>
      <div class="qrcode-box">
        <div class="img-qrcode-box">
          <img class="img-qrcode" src="@/assets/testqrcode.png" />
        </div>
      </div>
      <div class="scan-tip-box">
          <img class="img-scan" src="@/assets/icon_sweep.png" />
          <div class="tip-text">请使用微信“扫一扫”，登录小程序，绑定微信账户</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { phoneValidator } from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import imgCodeApi from "@/api/imgcode";
import accountApi from "@/api/account";
import sendpohnecodeMixin from "@/views/mixins/sendphonecode";
export default {
  name: "BindUserInfoQrcode",
  mixins: [sendpohnecodeMixin],
  data() {
    return {
      showDialog: false,
      formData: {
        content: "",
      },
      //发送验证码操作
      sendphoneValideForName: "modifyForm",
      sendPhoneFormeDataName: "formData",
      valideFieldPhoneItemName: "user_phone",
      //发送验证码结束------------------------
      imgCodeUrl: "",
      rules: {
        user_phone: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        msg_content: [
          { required: true, message: "填写手机验证码", trigger: "blur" },
        ],
        pic_code: [{ required: true, message: "填写验证码", trigger: "blur" }],
        password_user: [
          { required: true, message: "填写密码", trigger: "blur" },
        ],
      },
      isRequesting: false,
    };
  },
  mounted() {
    let _this = this;

  },
  methods: {
    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
      _this.$emit("CloseDialog")
    },

  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-binduserinfoqrcode {
  /deep/.el-dialog {
    position: absolute;
    width: 584px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 584px;
      padding: 0;
      padding-top: 30px;
      padding-right: 30px;
      padding-bottom: 7px;
      box-sizing: border-box;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      justify-content: flex-end;
      .icon-delete {
        position: relative;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0;
      padding-bottom: 50px;
      box-sizing: border-box;
      .dialog-container {
        position: relative;
        width: 100%;
        .title-box {
          width: 100%;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #313131;
          line-height: 24px;
          text-align: center;
        }
        .qrcode-box {
          position: relative;
          width: 300px;
          height: 300px;
          padding: 20px;
          border: 2px solid #222222;
          box-sizing: border-box;
          margin: 32px auto 0;
          .img-qrcode-box {
            width: 260px;
            height: 260px;
            border: 2px dotted #666666;
            padding: 10px;
            box-sizing: border-box;
            .img-qrcode {
              position: relative;
              width: 240px;
              height: 240px;
            }
          }
        }
        .scan-tip-box {
          position: relative;
          width: 334px;
          height: 83px;
          border: 2px solid #eaeaea;
          margin: 40px auto 0;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .img-scan{
              position: relative;
              width: 34px;
              height: 34px;
              margin-right: 24px;
          }
          .tip-text{
              position: relative;
              width: 240px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #666666;
              line-height: 26px;
          }
        }
      }
    }
    // .el-form-item {
    //   margin-bottom: 30px;
    // }
    .el-dialog__footer {
      position: relative;
      width: 100%;
      padding: 40px;
      box-sizing: border-box;
      text-align: center;
      .btn-submit {
        position: relative;
        width: 224px;
        height: 46px;
        line-height: 46px;
        text-align: center;

        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }

  // /deep/.dialog-footer {
  //   display: flex;
  //   justify-content: flex-end;
  //   .custom-button {
  //     width: 80px;
  //     height: 46px;
  //     line-height: 46px;

  //     font-size: 16px;

  //     margin-left: 25px;

  //     &:first-child {
  //       margin-left: 0;
  //     }
  //   }
  // }
}
</style>